"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTextToSpeechPolicy = validateTextToSpeechPolicy;
exports.validateClassTextToSpeechPolicy = validateClassTextToSpeechPolicy;
exports.resolveTextToSpeechPolicy = resolveTextToSpeechPolicy;
const ACTIVITY_POLICIES = ['inherit', 'on', 'off'];
const CLASS_POLICIES = ['year_group_default', 'on', 'off'];
function validateTextToSpeechPolicy(value) {
    return typeof value === 'string' && ACTIVITY_POLICIES.includes(value)
        ? { valid: true, errors: [] }
        : { valid: false, errors: ['textToSpeechPolicy must be inherit, on, or off'] };
}
function validateClassTextToSpeechPolicy(value) {
    return typeof value === 'string' && CLASS_POLICIES.includes(value)
        ? { valid: true, errors: [] }
        : { valid: false, errors: ['textToSpeechPolicy must be year_group_default, on, or off'] };
}
function resolveTextToSpeechPolicy({ stage, studentOverride, activityPolicy = 'inherit', classPolicy = 'year_group_default', }) {
    const enabled = studentOverride ?? (activityPolicy !== 'inherit'
        ? activityPolicy === 'on'
        : classPolicy !== 'year_group_default'
            ? classPolicy === 'on'
            : true);
    return { enabled, autoPlay: enabled && stage === 'EYFS' };
}
